<div class="nav-sublist">
  <ng-content select="wchfs-nav-sublist-title"></ng-content>
  <div>
    <ng-content></ng-content>
  </div>
</div>
